import React from 'react';
import { useFramework } from '@/framework';
import { PluginType, type IExportPlugin } from '@/version-types';
import { usePackHotkey } from './use-pack-hotkey';
import { useUnpackHotkey } from './use-unpack-hotkey';

/**
 * 编组 / 取消编组快捷键（子逻辑见 `use-*-hotkey.ts`）。
 */
const GroupLayerHotkeyView: React.FC = React.memo(() => {
    const framework = useFramework();

    usePackHotkey(framework);
    useUnpackHotkey(framework);

    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'group-layer-hotkey',
    render() {
        return <GroupLayerHotkeyView />;
    },
};

export default exportPlugin;
